<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">CONFIGURAZIONE AGENTI E LIMITE SCONTI</h1>
		</div>
		<div class="row">
			<div class="col-12">
				<!--LASCIARE ORDINAMENTO SOLO SU COLONNA CLIENTE AS400, LE SELECT DELLE ALTRE DUE COLONNE PARTONO DISABILITATE E IL BTN SALVA NASCOSTO. SI ATTIVA TUTTO AL CLICK SULLA MODIFICA-->
				<table datatable [dtOptions]="dtSettings" [dtTrigger]="dtTrigger" class="row-border hover">
					<thead>
						<tr>
							<th>Username</th>
							<th>Ruolo utente</th>
							<th>Limite sconto</th>
							<th>Agente collegato</th>
							<th></th>
							<th class="d-none">Limite sconto</th>
							<th class="d-none">Agente</th>
						</tr>
					</thead>
					<tbody *ngIf="utenti.length > 0">
						<tr *ngFor="let utente of utenti">
							<td>
								<span *ngIf="utente.ruolo === 'CLIENTE' && utente.agente">- &nbsp;</span>
								{{utente.username}}
							</td>
							<td>
								{{utente.ruolo}}
							</td>
							<td>
								<input
									class="dt-no-export font-weight-bold font-12 mr-2"
									name="limiteScontoPercentuale_{{utente.id}}"
									[disabled]="!utente.feEdit"
									[(ngModel)]="utente.limiteScontoPercentuale" />
								%
								<span class="d-none">{{utente.limiteScontoPercentuale}}%</span>
							</td>
							<td>
								<select
									*ngIf="utente.ruolo === 'CLIENTE'"
									class="dt-no-export minimal w-100  rounded-0 border-black"
									[disabled]="!utente.feEdit"
									name="idCS_{{utente.id}}"
									[(ngModel)]="utente.idAgente">
									<option [value]="undefined">SELEZIONA</option>
									<option *ngFor="let agente of agenti" [value]="agente.id">{{agente.username}}</option>
								</select>
							</td>
							<td>
								<button type="button" class="btn btn-bertazzoni black rounded-0" *ngIf="utente.feEdit" (click)="save(utente)">SALVA</button>
								<img src="assets/img/pencil.svg" class="action-icon" *ngIf="!utente.feEdit" (click)="utente.feEdit = !utente.feEdit" />
							</td>
							<td class="d-none">{{utente.limiteScontoPercentuale}} %</td>
							<td class="d-none">{{utente.agente?.username}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
